import React, { useEffect } from 'react';

import RiskSummary from '../Charts/Department/RiskSummary';
import ActionStatus from '../Charts/Department/ActionStatus';
import TopRisks from '../Charts/Department/TopRisks';
//import TopRisks from '../Charts/General/Notifications.js';
import Matrix from '../Charts/Department/Matrix';
import ComplianceMeters from "../Meters/ComplianceMeters";

import { connect } from "react-redux";
import { compose } from "redux";

import { getComplianceDashboardData } from "../../store/actions/dashboardActions";

const ComplianceDashboard = (props) => {
    const { compliance_id, compliance_dashboard_data, getComplianceDashboardDataFN, setComplianceDashboardData } = props;

    //console.log(props);
    //console.log('compliance_id:', compliance_id);
    useEffect(() => {
        //console.log("Use effect triggered!");
        getComplianceDashboardDataFN(compliance_id);
    }, [compliance_id, getComplianceDashboardDataFN]);

    //console.log('compliance_dashboard_data:', compliance_dashboard_data);

    useEffect(() => {
        //console.log("✅ useEffect triggered on mount! compliance_id:", compliance_id);
        
        if (compliance_id) {
            getComplianceDashboardDataFN(compliance_id);
        }
    }, []); 

    useEffect(() => {
        setComplianceDashboardData(compliance_dashboard_data);
    }, [compliance_dashboard_data, setComplianceDashboardData]);

    //console.log(compliance_dashboard_data);

    return (
        compliance_dashboard_data ? (
            <div className="flex flex-col" style={{ minHeight: `calc(100vh - 245px)` }}>
                
                <div className="flex-1"> {/* Ensured this div takes full height for alignment */}
                     <ComplianceMeters compliance_id={compliance_id} />
                </div>

 {/* First Row */}
            <div className="flex flex-grow w-full">
                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <h2 className="text-base font-bold m-0">Compliance Summary</h2>
                    </div>
                    <div className="contents">
                        <RiskSummary height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.risk_summary} />
                    </div>
                </div>

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <h2 className="text-base font-bold m-0">Action Status</h2>
                    </div>
                    <div className="contents">
                        <ActionStatus height={(window.innerHeight - 550) / 2} data={compliance_dashboard_data.action_status} />
                    </div>
                </div>

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <h2 className="text-base font-bold m-0">Top Compliance Risks</h2>
                    </div>
                    <div className="contents p-2">
                        <TopRisks height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.top_5_compliance_risks} />
                    </div>
                </div>
            </div>

            {/* Second Row */}
            <div className="flex flex-grow w-full mt-4">
                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <h2 className="text-base font-bold m-0">Inherent Compliance Risk</h2>
                    </div>
                    <div className="contents p-2">
                        <Matrix height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.inherent_matrix} which="inherent" />
                    </div>
                </div>

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <h2 className="text-base font-bold m-0">Residual Compliance Risk</h2>
                    </div>
                    <div className="contents p-2">
                        <Matrix height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.residual_matrix} which="residual" />
                    </div>
                </div>

                <div className="w-[30%] bg-[#FFFFFF] shadow-lg rounded-[5px] border border-gray-150 m-4 ml-6">
                    <div className="bg-[#3b3b3b] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] border-b border-gray-300">
                        <h2 className="text-base font-bold m-0">Future Compliance Risk</h2>
                    </div>
                    <div className="contents p-2">
                        <Matrix height={(window.innerHeight - 450) / 2} data={compliance_dashboard_data.future_matrix} which="future" />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div>Loading Compliance Dashboard...</div>
    ));
};

const mapStateToProps = (state) => {
    console.log("Redux state:", state.dashboard.compliance_dashboard_data);
    return {
        compliance_dashboard_data: state.dashboard.compliance_dashboard_data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getComplianceDashboardDataFN: (compliance_id) => dispatch(getComplianceDashboardData(compliance_id)),
    };
};



export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceDashboard);